import { Component, inject, OnInit } from '@angular/core';
import { BoRolesCheckService } from "../../../../components/rolesCheck/bo-roles-check.service";
import { CpaasClientsService } from '../cpaas-clients.service';
import { CdrProcessingService } from '../cdr-processing.service';
import { CpaasClient, CPAAS_CLIENTS } from '../cdr-clients.constants';

const CDR_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'CPAAS_SMS', label: 'CPAAS_SMS' }
];

@Component({
  selector: 'app-cdr-processing',
  templateUrl: './cdr-processing.component.html',
  styleUrls: ['./cdr-processing.component.scss']
})
export class CdrProcessingComponent implements OnInit {
  rolesCheck  = inject(BoRolesCheckService);
  private clientsSvc = inject(CpaasClientsService);
  private cdrSvc     = inject(CdrProcessingService);

  cdrFiles  : File[]        = [];
  isLoading                 = false;

  typeOptions               = CDR_TYPE_OPTIONS;
  clientOptions: CpaasClient[] = [];

  selectedType   = CDR_TYPE_OPTIONS[0].value;
  selectedClient = CPAAS_CLIENTS[0].code;

  pricePerSms    = 0.02;
  outputFilename = '';
  logMessages: string[] = [];

  async ngOnInit() {
    const canAccess = await this.rolesCheck.checkAccess();
    if (!canAccess) return;

    this.clientsSvc.getClients().subscribe(clients => {
      this.clientOptions = clients;
      if (clients.length > 0) this.selectedClient = clients[0].code;
      this.updateOutputFilename();
    });
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.cdrFiles = Array.from(input.files);
      this.updateOutputFilename();
    }
  }

  onClientChange(): void {
    this.updateOutputFilename();
  }

  updateOutputFilename(): void {
    this.outputFilename = `CDR_${this.selectedClient}_${this.extractDateFromFilename()}`;
  }

  async processFile(): Promise<void> {
    if (this.cdrFiles.length === 0) return;
    this.isLoading = true;
    this.clearLog();

    try {
      this.log(`Iniciando procesamiento de ${this.cdrFiles.length} archivo(s)`);
      this.log(`Filtro de tipo: ${this.selectedType}`);
      this.log(`Precio por SMS: ${this.pricePerSms}`);
      this.log('─'.repeat(50));

      let allRows: any[] = [];

      for (const file of this.cdrFiles) {
        this.log(`\n📄 Fichero: ${file.name}`);
        const result = await this.cdrSvc.processBlob(file, this.pricePerSms, this.selectedType);
        result.log.forEach(l => this.log(l));
        allRows = allRows.concat(result.rows);
      }

      this.log('\n' + '─'.repeat(50));
      this.log(`RESUMEN:`);
      this.log(`   Total filas procesadas: ${allRows.length}`);

      if (allRows.length > 0) {
        const rowsWithTotal = this.cdrSvc.addTotalRow(allRows, this.pricePerSms);
        this.cdrSvc.generateXlsx(rowsWithTotal, this.outputFilename);
        const totalSegments = allRows.reduce((s, r) => s + (typeof r['Segmentos'] === 'number' ? r['Segmentos'] : 0), 0);
        this.log(`   Total segmentos: ${totalSegments}`);
        this.log(`   Total precio: ${(totalSegments * this.pricePerSms).toFixed(5)}`);
        this.log(`\n✅ Fichero generado: ${this.outputFilename}.xlsx`);
      } else {
        this.log(`\n⚠️ No se encontraron filas válidas para generar el fichero`);
      }
    } catch (error) {
      this.log(`\n❌ Error: ${error}`);
    } finally {
      this.isLoading = false;
    }
  }

  get logText(): string { return this.logMessages.join('\n'); }

  private log(message: string): void   { this.logMessages.push(message); }
  private clearLog(): void              { this.logMessages = []; }

  private extractDateFromFilename(): string {
    if (this.cdrFiles.length === 0) return 'unknown';
    const dates = new Set<string>();
    for (const file of this.cdrFiles) {
      const match = file.name.match(/(\d{4}-\d{2})/);
      if (match) dates.add(match[1]);
    }
    const sorted = Array.from(dates).sort();
    return sorted.length > 0 ? sorted.join('_') : 'unknown';
  }
}
